<template>
    <div>
        <map-tool 
          mapType="user"
          :checkLogin="true">
        </map-tool>
    </div>
</template>

<script>
import MapTool from '../../components/MapTool.vue'

export default {
  components: { MapTool },
  name: "EventTool"
}
</script>


